<template>
  <modal
    :isShow.sync="visible"
    :title="'预览'"
    :isShowBtn="[false,false]"
    :width="'722px'"
  >
    <div class="content">
      <p class="before-content-color title">
        <span class="before-icon"></span>
        移动端链接
      </p>
      <div class="image">
        <div class="flexs middle-a dialog-btns middle-a">
          <el-input
            class="dialog-input"
            v-model="url"
            placeholder="请输入移动端链接"
          ></el-input>
          <el-button class="color" type="text" size="small">
            <a :href="url" target="_blank">打开</a>
          </el-button>
          <el-button type="text" size="small" @click="copyUrl(url)">
            复制
          </el-button>
        </div>
        <p class="dislog-sub-title">
          *预览页面不可用于商业用途，链接有效时间5分钟，超时过期请重新打开预览弹窗！
        </p>
        <div class="qrCode">
          <img :src="qrCode" alt="二维码图片" />
        </div>
        <div class="img-des">扫描二维码手机查看</div>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
import { copyUrl } from "@/utils/tools";

export default {
  name: "previewModal",
  props: ['dialogPreVisible','qrCode','mUrl'],
  computed: {
    visible: {
      get() {
        return this.dialogPreVisible
      },
      set(val) {
        this.$emit('update:dialogPreVisible',val)
      }
    },
    url: {
      get() {
        return this.mUrl
      },
      set(val) {
        this.$emit('update:mUrl',val)
      }
    }
  },
  methods: {
    copyUrl(content) {
      copyUrl(content,this)
    },
  },
  components: {
    modal
  }
}
</script>

<style lang="scss" scoped>

.content {
  padding: 26px 25px 18px 26px;
}

.image {
  margin-top: 20px;

  .dialog-input {
    width: 558px;
  }

  .dislog-sub-title {
    color: #8b8c9a;
    font-size: 12px;
    margin-top: 14px;
  }

  .color {
    margin-left: 24px;
  }

  .qrCode {
    width: 182px;
    height: 182px;
    margin: 60px auto;
    margin-bottom: 0px;
  }

  .img-des {
    margin: 0 auto;
    width: 182px;
    text-align: center;
  }
}
</style>
